'use client';

import { useTranslations } from 'next-intl';

import { SearchBar } from 'antd-mobile';

import SearchIcon from '@/assets/svg/search.svg';
import { LeftArrowIcon } from '@/components/icon-svg';

interface ISearingHeaderProps {
    keyword: string;
    onKeywordChange: (value: string) => void;
    onSearch: (value: string) => void;
    onBack: () => void;
}

export default function SearingHeader(props: ISearingHeaderProps) {
    const { keyword, onKeywordChange, onBack, onSearch } = props;

    const t = useTranslations('Discover');

    return (
        <header className='header-search-bar absolute left-0 top-0 z-10 flex h-[52px] w-full items-center justify-between gap-[12px] bg-white py-[8px] pl-[12px] pr-[16px]'>
            <button type='button' className='size-[24px]' onClick={onBack}>
                <LeftArrowIcon size={24} />
            </button>
            {/* <div className='searing-search-field h-[36px] w-[311px] rounded-[18px] bg-[#F3F3F3] px-[12px] py-[6px]'> */}
            <SearchBar
                searchIcon={
                    <div className='size-[24px]'>
                        <SearchIcon />
                    </div>
                }
                className='size-full rounded-[18px]'
                style={{ '--background': '#F3F3F3', '--height': '100%', '--border-radius': '0.48rem' }}
                value={keyword}
                placeholder={t('search_input')}
                maxLength={100}
                autoFocus
                onChange={onKeywordChange}
                onSearch={onSearch}
            />
            {/* </div> */}
        </header>
    );
}
